import { render } from "./UsersCard.vue?vue&type=template&id=674645e6&scoped=true"
import script from "./UsersCard.vue?vue&type=script&lang=js"
export * from "./UsersCard.vue?vue&type=script&lang=js"

import "./UsersCard.vue?vue&type=style&index=0&id=674645e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674645e6"]])

export default __exports__